/* esm.sh - @smithy/core@3.24.3/client */
export * from "/*@smithy/core@3.24.3/esnext/client.mjs";
